import { useQuery } from '@tanstack/react-query';
import { useSelector } from 'react-redux';

import { SafariPortalIconStyles } from 'constants/fontAwesome';
import api from 'utils/axios';

import { accountIdSelector } from '../../../../../../store/user/selectors';

export interface IIconSearchResult {
  id: string;
  label: string;
  icon: string;
  style: SafariPortalIconStyles;
  family: 'classic' | 'sharp' | 'duotone';
}

export function useIconsSearch(query: string) {
  const accountId = useSelector(accountIdSelector);

  return useQuery<IIconSearchResult[]>(
    ['icons', query],
    async () => await api.get(`/acc/${accountId}/icon_search?name=${query}`).then(({ data }) => data),
    {
      staleTime: 1000 * 60,
      enabled: Boolean(query),
    },
  );
}
